import React from 'react';
import { Link } from 'gatsby';
import './layout.css';

function Layout(_ref) {
  var location = _ref.location,
      title = _ref.title,
      children = _ref.children,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'w-11/12 md:w-10/12 lg:w-9/12 xl:w-7/12' : _ref$width;
  var isInBlog = location.pathname.startsWith('/blog');
  var homePath = isInBlog ? '/blog' : '/';
  var padding = isInBlog ? 'lg:pr-64' : '';
  var header = location.pathname === '/blog' ? /*#__PURE__*/React.createElement("h1", {
    className: "text-4xl font-bold mt-12 mb-6 text-center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: homePath,
    className: "no-underline"
  }, title)) : /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(Link, {
    to: homePath,
    className: "text-ocean-800 text-base not-italic no-underline"
  }, "Back to ", title));
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col leading-normal " + padding
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto p-5 md:p-8 my-6 bg-gray-100 min-h-screen text-ocean-800 shadow-lg flex-auto " + width
  }, /*#__PURE__*/React.createElement("header", null, header), /*#__PURE__*/React.createElement("main", null, children)), /*#__PURE__*/React.createElement("footer", {
    className: "text-sm text-ocean-200 mt-2 mb-8 self-center"
  }, "\xA9 ", new Date().getFullYear(), " Matthew Nelson", /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: "ml-14"
  }, "Back to Homepage")));
}

export default Layout;